import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { InputTextModule } from 'primeng/inputtext';
import { AuthService } from 'src/app/shared/services';

@Component({
    selector: 'app-recover-password',
    imports: [
        CardModule,
        CommonModule,
        ButtonModule,
        ReactiveFormsModule,
        FormsModule,
        InputTextModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './recover-password.component.html',
    standalone: true,
    styles: ``
})
export class RecoverPasswordComponent implements OnInit {
  
  private ar = inject(ActivatedRoute);
  private router = inject(Router);
  private authService = inject(AuthService);

  public email:string;

  public hasRequested:boolean = false;

  ngOnInit(): void {
    this.ar.queryParams.subscribe(params => {
      this.email = params['email']
    });
  }

  resetPassword(): void { 
    this.authService.sendResetEmail(this.email);
    this.hasRequested = true;
  }

  goToLogin(): void {
    this.router.navigate(['/auth/login']);
  }

}
